export default __webpack_public_path__ + "static/media/CryptoCup.b4775c39.png";